import { Association, Community } from "@entities";
import { extender } from "@shared/backend/class-extender";
import HyperEntity from "@shared/backend/hyper-entity.decorator";
import { Fields, Relations } from "remult";
import { CommunityAssociationEntityConfig } from "./config";
import { CommunityAssociationFilters } from "./filters";
import { CommunityAssociationMethods } from "./methods";

@HyperEntity("community-association", CommunityAssociationEntityConfig)
export class CommunityAssociation extends extender(
  CommunityAssociationFilters,
  CommunityAssociationMethods,
) {
  @Fields.string({
    dbName: "community_id",
  })
  communityId = "";

  @Fields.string({
    dbName: "association_id",
  })
  associationId = "";

  @Relations.toOne<CommunityAssociation, Community>(
    () => Community,
    "communityId",
  )
  community?: Community;

  @Relations.toOne<CommunityAssociation, Association>(
    () => Association,
    "associationId",
  )
  association?: Association;

  @Fields.boolean({ dbName: "is_leader", defaultValue: () => false })
  isLeader = false;

  @Fields.createdAt({
    dbName: "created_at",
  })
  createdAt = new Date();

  @Fields.updatedAt({ dbName: "updated_at" })
  updatedAt = new Date();
}
